'use client';
var classes = {"root":"m_de3d2490","colorOverlay":"m_862f3d1b","shadowOverlay":"m_98ae7f22","alphaOverlay":"m_95709ac0","childrenOverlay":"m_93e74e3"};

export { classes as default };
//# sourceMappingURL=ColorSwatch.module.css.mjs.map
